import { UseTRPCQueryResult } from '@trpc/react-query/shared';
import { addDays } from 'date-fns';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';

import { AblaufTag, AkaThemaId } from '../../../dtos';
import { trpc } from '../../../trpc';
import { FilterParameters } from '../ResourceCalendar';

function createQueryRange(istTerminreihe: boolean, timeRange: AblaufTag) {
  // queryRange widened to check validity of terminreihen out of view - if performance goes down reassess this
  // Only for Terminreihen because this creates problems for the "freieTage" filter (sometimes rooms without free days in the view range)
  return {
    start: istTerminreihe ? addDays(timeRange.start, -15) : timeRange.start,
    end: istTerminreihe ? addDays(timeRange.end, 15) : timeRange.end,
  };
}

function useHandleError(message: string, queryResult: UseTRPCQueryResult<unknown, unknown>) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (queryResult.error) {
      console.error(queryResult.error);
      enqueueSnackbar({ message, variant: 'error', persist: true });
    }
  }, [queryResult.error, enqueueSnackbar, message]);
}

export function useExperten({
  istTerminreihe,
  timeRange,
  akaThemaId,
}: {
  istTerminreihe: boolean;
  timeRange: AblaufTag;
  akaThemaId: AkaThemaId;
}) {
  const queryRange = createQueryRange(istTerminreihe, timeRange);
  const experten = trpc.planung.resources.getBookableExpertenByThema.useQuery({
    akaThemaId,
    ...queryRange,
  });
  useHandleError('Fehler beim Laden der Experten', experten);
  return experten;
}

export function useStandorte({
  istTerminreihe,
  timeRange,
  standortSapIds,
}: {
  istTerminreihe: boolean;
  timeRange: AblaufTag;
  standortSapIds: number[];
}) {
  const queryRange = createQueryRange(istTerminreihe, timeRange);
  const standorte = trpc.planung.resources.getStandorte.useQuery({
    standortSapIds,
    ...queryRange,
  });
  useHandleError('Fehler beim Laden der Standorte', standorte);
  return standorte;
}

export function useLocationsWithRaeume({
  istTerminreihe,
  timeRange,
  filterParams,
}: {
  istTerminreihe: boolean;
  timeRange: AblaufTag;
  filterParams: FilterParameters;
}) {
  const queryRange = createQueryRange(istTerminreihe, timeRange);
  const locationsWithRaeume = trpc.planung.resources.getLocationsWithRaeume.useQuery({
    ...filterParams,
    ...queryRange,
  });
  useHandleError('Fehler beim Laden der Locations & Räume', locationsWithRaeume);
  return locationsWithRaeume;
}
